export const DELIVERY_FEE = 5;

export default function ShippingOptions({ hasMerch, shippingMethod, onChange }) {
  const options = [
    { value: 'self-collection', label: hasMerch ? 'NTU self-collection (25–27 January 2027, 1–5 PM, SAC) - Free' : 'Self-Collection (Carnival) - Free' },
    ...(hasMerch ? [{ value: 'delivery', label: `Tracked delivery (January 2027): $${DELIVERY_FEE.toFixed(2)}` }] : []),
  ];
  return <fieldset className="space-y-3">
    <legend className="text-sm text-gray-700 mb-3">Collection / delivery</legend>
    {options.map(option => <label key={option.value} className="flex items-center gap-3 cursor-pointer">
      <input type="radio" name="shipping" value={option.value} checked={shippingMethod === option.value}
        onChange={() => onChange(option.value)} className="w-4 h-4 flex-shrink-0" />
      <span className="text-gray-700 text-sm">{option.label}</span>
    </label>)}
  </fieldset>;
}
